import { Alert } from "@mui/material";

const ReportIsDeletedAlert = () => {
  return (
    <Alert severity="warning" sx={{ mb: 2, width: "100%" }}>
      This report is no longer available. It appears to have been deleted from the system.
    </Alert>
  );
};

export default ReportIsDeletedAlert;
